import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from "@msdyn365-commerce/retail-proxy";
import * as DataServiceEntities from './AlternateItemsEntity.g';

  export function gCCreateAccountRequestInput (
      newAccountEntity:
          DataServiceEntities.INewAccountEntity,
          comment:
          string,
          token:
          string,
          secretKey:
          string,
          apiConfiguration:
          DataServiceEntities.IAPIConfiguration
  ): IDataServiceRequest {
    const query = gCCreateAccountRequestQuery();
    return query.createDataServiceRequestForOperation(
        'GCCreateAccountRequest',
        true,
          DataServiceEntities.NewAccountResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.INewAccountResponse' },
        {
        newAccountEntity: newAccountEntity,
          Comment: comment,
          token: token,
          secretKey: secretKey,
          apiConfiguration: apiConfiguration
        }
    );
  }

  function gCCreateAccountRequestQuery(): DataServiceQuery {
    return new DataServiceQuery();
    }

  export function gCCreateAccountRequestAsync (
      context: IContext, newAccountEntity:
          DataServiceEntities.INewAccountEntity,
          comment:
          string,
          token:
          string,
          secretKey:
          string,
          apiConfiguration:
          DataServiceEntities.IAPIConfiguration
      ): AsyncResult<DataServiceEntities.INewAccountResponse> {
      const request = gCCreateAccountRequestInput(newAccountEntity, comment,token,secretKey, apiConfiguration);
      return callActionOrExecute<DataServiceEntities.INewAccountResponse>(request, context.callerContext);
  }

